import React, { useEffect, useState } from "react";
import { useContextDispatch, useContextState } from "services/context/MainContext";
import { actionTypes } from "services/context/reducer";
import TopMenu from "./TopMenu";
import DrawerMenu from "./DrawerMenu";


export default function HeaderMenu({ installer, setInstaller, loading }) {

    const [openMenu, setOpenMenu] = useState(false)
    const { userInfo } = useContextState()

    const handleSlideMenu = (status) => {
        setOpenMenu(status)
    }

    return (
        <>
            <TopMenu data={userInfo} loading={loading} setOpenMenu={handleSlideMenu} />
            <DrawerMenu installer={installer} setInstaller={setInstaller} data={userInfo} loading={loading} openMenu={openMenu} setOpenMenu={handleSlideMenu} />
        </>
    )
}